import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

export default function CustomerOrders() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

  useEffect(() => {
    if (user === false) {
      navigate("/login");
    } else if (user) {
      axios.get(`${API}/orders/me`, { withCredentials: true })
        .then(res => setOrders(res.data))
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [user, navigate, API]);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  if (!user) return <div className="min-h-screen bg-noir" />;

  return (
    <div className="min-h-screen bg-noir px-6 py-20 grain-overlay text-white" data-testid="customer-orders-page">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-end border-b border-white/10 pb-6 mb-10">
          <div>
            <h1 className="font-serif-lux text-3xl tracking-[0.15em] uppercase text-gold">Mis Pedidos</h1>
            <p className="text-neutral-400 mt-2 font-light">Hola, {user.name}</p>
          </div>
          <div className="flex gap-4">
            <Link to="/" className="text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-white transition-colors">Tienda</Link>
            <button onClick={handleLogout} className="text-xs uppercase tracking-[0.2em] text-red-500 hover:text-red-400 transition-colors">Salir</button>
          </div>
        </div>

        {loading ? (
          <p className="text-neutral-500">Cargando...</p>
        ) : orders.length === 0 ? (
          <div className="text-center py-20 border border-white/5 bg-white/[0.02]">
            <p className="text-neutral-500 font-light mb-6">Aún no tienes pedidos.</p>
            <Link to="/" className="text-xs uppercase tracking-[0.2em] text-gold border border-gold/50 px-8 py-3 hover:bg-gold hover:text-black transition-colors">
              Explorar Colección
            </Link>
          </div>
        ) : (
          <div className="space-y-6">
            {orders.map(order => (
              <motion.div initial={{opacity:0, y:10}} animate={{opacity:1, y:0}} key={order.id} className="border border-white/10 bg-noir-soft p-6">
                <div className="flex justify-between items-start border-b border-white/5 pb-4 mb-4">
                  <div>
                    <span className="text-[10px] text-neutral-500 uppercase tracking-widest block mb-1">Pedido #{order.id.slice(0, 8)}</span>
                    <span className="text-xs text-neutral-400">{new Date(order.created_at).toLocaleDateString()}</span>
                  </div>
                  <div className="text-right">
                    <span className="font-serif-lux text-xl text-gold">{order.total.toFixed(2)} €</span>
                    <span className="block text-[10px] uppercase tracking-widest text-neutral-500 mt-1">{order.status}</span>
                  </div>
                </div>
                <div className="space-y-3">
                  {order.items.map((item, i) => (
                    <div key={i} className="flex justify-between text-sm">
                      <span className="text-neutral-300">{item.name} <span className="text-neutral-600">x{item.quantity}</span></span>
                      <span className="text-neutral-400">{(item.price * item.quantity).toFixed(2)} €</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
